<template>
  <section>
    <div class="inactive">
      <img
        src="~@/assets/images/banners/documents-sarah_atestados.svg"
        alt="Atendimento"
        class="is-hidden-mobile"
      />
      <div class="inactive-info">
        <p>{{ mensagem }}</p>
        <b-button v-if="botao" class="btn-orange" @click="$emit('botaoClick')">
          {{ textoBotao }}
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InformacaoAcao',
  props: {
    mensagem: {
      type: String,
      default: ''
    },
    textoBotao: {
      type: String,
      default: 'Ok'
    },
    botao: {
      type: Boolean,
      default: true
    }
  },
  computed: {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

.inactive {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 3.75rem;

  .inactive-info .button {
    margin-top: 2rem;
  }
}
</style>
